import { AuthenticationService } from './../authentication.service';
import { CustomLoadingService } from './../../shared/custom-loading/custom-loading.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { AppSettingService } from 'src/app/services/app-setting.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, Subject } from 'rxjs';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit, OnDestroy {

  ngOnDestroy(): void {
    this.clearLocalVarialbles();
    this.subscription.unsubscribe()

  }

  clearLocalVarialbles() {

    this.registerForm = null;


  }
  public registerForm: FormGroup;
  private subscription: Subscription = new Subscription()
  errorMessage = ""

  timeouts: any;

  constructor(

    public appSettingService: AppSettingService,
    public route: Router,
    public activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    public customLoadingService: CustomLoadingService,
    public translateService: TranslateService
  ) { }


  ngOnInit() {


    //Register Forms
    this.registerForm = this.formBuilder.group({
      TaxIdOrSsn: ['', Validators.compose([Validators.required, Validators.minLength(9)]), this.isTaxIdExist.bind(this)],
      Email: ['', Validators.compose([Validators.required, Validators.minLength(5), Validators.email]), this.isUniqueEmailAddress.bind(this)],
      Password: ['', Validators.compose([Validators.required, Validators.minLength(8)]), this.validatePassword.bind(this)],
      ConfirmPassword: ['', Validators.compose([Validators.required]), this.isMatchingPassword.bind(this)],

    });

    var routerClassName = ""
    this.activatedRoute
      .data

      .subscribe(className => {
        routerClassName = className["activeClass"];
        document.getElementById('body').className = routerClassName;
      });
  }
  validatePassword(control: FormGroup) {

    const q = new Promise((resolve, reject) => {
      setTimeout(() => {
        var pattern = /^.*(?=.{8,})((?=.*[!#*$%\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/;

        if (pattern.test(control.value)) {
          resolve(null);
        }
        else
          resolve({ 'isValidPassword': true });

      }, 100);
    });
    return q;

  }
  isMatchingPassword(control: FormControl) {
    const q = new Promise((resolve, reject) => {
      setTimeout(() => {
        if (control.value == this.registerForm.controls["Password"].value) {
          resolve(null);
        }
        else
          resolve({ 'isMatchingPassword': true });

      }, 100);
    });
    return q;
  }


  isUniqueEmailAddress(control: FormControl) {
    const q = new Promise((resolve, reject) => {
      setTimeout(() => {
        this.authenticationService.isUniqueEmailAddress(control.value)
          .subscribe((res) => {
            if (res) {
              resolve(null);
            }
            else {
              resolve({ 'isUnique': true });
            }
          }, () => { resolve({ 'isUnique': true }); });
      }, 1000);
    });
    return q;
  }

  isTaxIdExist(control: FormControl) {
    const q = new Promise((resolve, reject) => {
      setTimeout(() => {
        this.authenticationService.isTaxIdExist(control.value)

          .subscribe((res) => {
            if (res == 1) {
              resolve(null);
            }
            else if (res == 2) {
              resolve({ 'inUse': true });
            }
            else {
              resolve({ 'isValid': true });
            }

          }, () => { resolve({ 'isValid': true }); });
      }, 1000);
    });
    return q;
  }

  register(model: any, valid: boolean) {

    if (valid) {



      this.customLoadingService.show()
      this.authenticationService.register(model)

        .subscribe(res => {
          if (res > 0) {
            this.route.navigate(["/registration/success"])
            this.customLoadingService.hide();
          }
          else
            if (res == -1) {
              this.errorMessage =this. translateService.instant("Register.Error.Registered")
            }
        },
          error => {
            if (error.status === 400) {
              this.errorMessage =this. translateService.instant("Common.Error.UnexpectedError")
            }
            this.customLoadingService.hide();
          },
          () => { this.customLoadingService.hide() }
        );

    }

  }



}